
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Text from '../../common/client/components/Text';

import theme from '../common/theme';

const classNames = mergeStyleSets({
    root: {
        paddingBottom: 8
    }
});

const OverviewTitle = (props) => {
    return (
        <div className={classNames.root}>
            <Text large bold color={theme.fabricTheme.palette.neutralTertiary}>{props.title}</Text>
        </div>
    )
};

export default OverviewTitle;
